import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const userService = {
	list(params?: ListParams) {
		return apiClient.get("/users", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/users/${id}`).then((r) => r.data);
	},
	create(data: Record<string, unknown>) {
		return apiClient.post("/users", data).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/users/${id}`, data).then((r) => r.data);
	},
	remove(id: number) {
		return apiClient.delete(`/users/${id}`).then((r) => r.data);
	},
	updateStatus(id: number, status: string) {
		return apiClient.patch(`/users/${id}/status`, { status }).then((r) => r.data);
	},
	resetPassword(id: number, newPassword: string) {
		return apiClient.post(`/users/${id}/reset-password`, { new_password: newPassword }).then((r) => r.data);
	},
};
